import { useEffect, useRef, useState } from "react";
import {
  materializeUploadFile,
  UPLOAD_READ_ERROR_MESSAGE,
} from "../../utils/uploadFiles";

export const useMaterializedUploads = (setUploadImg, setModalAlert) => {
  const [materializingUploads, setMaterializingUploads] = useState({});
  const uploadGeneration = useRef({});
  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const handleDropzone = (target) => async (files) => {
    const selected = files[0];
    if (!selected) return;

    const generation = (uploadGeneration.current[target] || 0) + 1;
    uploadGeneration.current[target] = generation;
    setMaterializingUploads((current) => ({ ...current, [target]: true }));

    try {
      const file = await materializeUploadFile(selected.file, selected.data);
      if (!mounted.current || uploadGeneration.current[target] !== generation)
        return;
      setUploadImg((current) => ({
        ...current,
        [target]: file,
        [`${target}Label`]: file.name,
        [`${target}Preview`]: { ...selected, file },
      }));
    } catch {
      if (!mounted.current || uploadGeneration.current[target] !== generation)
        return;
      setModalAlert((current) => ({
        ...current,
        modalOpen: true,
        modalTitle: "We couldn't read your file",
        modalContent: UPLOAD_READ_ERROR_MESSAGE,
        modalSuccess: false,
      }));
    } finally {
      if (mounted.current && uploadGeneration.current[target] === generation) {
        setMaterializingUploads((current) => ({
          ...current,
          [target]: false,
        }));
      }
    }
  };

  const handleDropzoneDelete = (target) => async () => {
    uploadGeneration.current[target] =
      (uploadGeneration.current[target] || 0) + 1;
    setMaterializingUploads((current) => ({ ...current, [target]: false }));
    setUploadImg((current) => ({
      ...current,
      [target]: null,
      [`${target}Label`]: "",
      [`${target}Preview`]: null,
    }));
  };

  return {
    handleDropzone,
    handleDropzoneDelete,
    isMaterializingUpload: Object.keys(materializingUploads).some(
      (target) => materializingUploads[target]
    ),
  };
};
